module.exports = __webpack_public_path__ + "static/media/998039.66278f27.jpg";